import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
export function mentionVariantForKind(kind) {
    switch (kind) {
        case 'device':
            return 'device';
        case 'source':
            return 'sources';
        case 'space':
            return 'space';
        case 'plugin':
            return 'plugin';
        case 'skill':
            return 'skills';
        default:
            return assertUnreachableValue(kind);
    }
}
export function mentionPropsForSemanticMention(mention) {
    const { id: uuid, kind, ...props } = mention;
    return { ...props, uuid, variant: mentionVariantForKind(kind) };
}
//# sourceMappingURL=mentionVariant.js.map